<div class="container">
  <p class="title" innerHTML="{{ 'HOTEL_DETAIL.services' | translate }}">Servicios</p>
  <ul>
    <ng-container *ngFor="let amenity of amenities; let i = index;">
      <li *ngIf="i < 5"><p>{{amenity.value}}</p></li>
    </ng-container>
  </ul>
</div>
